import { Component } from '@angular/core';

@Component({
    selector: 'app-unauthorized',
    template: `
    <div class="unauthorized-container">
      <h4> Unauthorized Access </h4>
      <p>You are not authorized to access the resource.</p>
    </div>
  `,
    styles: [`
    .unauthorized-container {
       width: 100%;
      height: 170px;
      padding:37px 32px;
      font-family: 'Roboto';
      display: flex;
      flex-direction: column;
      align-items: center;
    }    
    h4 {
      color: #10172e;
      font-weight: 500;
      font-size: 22px;
      line-height: 26px;
      width: 330px;
    }
    button {
      margin-top: 20px;
      padding: 10px 20px;
      background-color: #1976d2;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
    }
  `]
})
export class UnauthorizedComponent {
  getCurrentPath(): string {
    return window.location.pathname;
  }

  retry() {
    window.location.href = '/';
  }
}